"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});
var e,
  t,
  r = require("date-fns");
exports.FieldType = void 0, (e = exports.FieldType || (exports.FieldType = {})).METRIC = "metric", e.BUCKET = "bucket", e.DATE = "date", e.URL = "url", exports.MetricType = void 0, (t = exports.MetricType || (exports.MetricType = {})).Count = "count", t.Sum = "sum", t.Avg = "avg", t.Min = "min", t.Max = "max", t.First = "first", t.Last = "last", t.Median = "median";
var o,
  i,
  p,
  n,
  a,
  s,
  c,
  u = [exports.MetricType.Sum, exports.MetricType.Avg, exports.MetricType.Min, exports.MetricType.Max, exports.MetricType.First, exports.MetricType.Last, exports.MetricType.Median];
exports.NumericMetricDisplay = void 0, (o = exports.NumericMetricDisplay || (exports.NumericMetricDisplay = {})).Regular = "regular", o.Percentage = "percentage", exports.BiWebComponent = void 0, (i = exports.BiWebComponent || (exports.BiWebComponent = {})).Highcharts = "arclab-bi-highcharts", i.Picker = "arclab-bi-picker", i.Select = "arclab-bi-select", i.AgGrid = "arclab-bi-ag-grid", i.AgGridV26X = "arclab-bi-ag-grid-v26-x", i.Kpi = "arclab-bi-kpi", i.SinglePicker = "arclab-bi-single-picker", i.DateRangePicker = "arclab-date-range", exports.ExternalComponent = void 0, (exports.ExternalComponent || (exports.ExternalComponent = {})).DateTimePicker = "sgwt-datetime-picker", exports.DateMode = void 0, (p = exports.DateMode || (exports.DateMode = {})).MONTH = "MONTH", p.YEAR = "YEAR", p.QUARTER = "QUARTER", p.DAY = "DAY", p.DAYDATE = "DAYDATE", p.SEMESTER = "SEMESTER", p.WEEK = "WEEK", exports.SortType = void 0, (n = exports.SortType || (exports.SortType = {})).Ascending = "asc", n.Descending = "desc", exports.OutputType = void 0, (a = exports.OutputType || (exports.OutputType = {})).Bucket = "bucket", a.Metric = "metric", a.Date = "date", a.Url = "url", exports.FilterType = void 0, (s = exports.FilterType || (exports.FilterType = {})).Picker = "picker", s.Select = "select", s.SinglePicker = "single-picker", s.DateTimePicker = "datetime-picker", s.DateRangePicker = "date-range-picker";
var T,
  d,
  l,
  x,
  y,
  A,
  E,
  g,
  R,
  v,
  f,
  C = ((c = {})[exports.MetricType.Count] = function () {
    return "Count";
  }, c[exports.MetricType.Avg] = function (e) {
    return "Avg(" + e + ")";
  }, c[exports.MetricType.First] = function (e) {
    return "First(" + e + ")";
  }, c[exports.MetricType.Last] = function (e) {
    return "Last(" + e + ")";
  }, c[exports.MetricType.Max] = function (e) {
    return "Max(" + e + ")";
  }, c[exports.MetricType.Min] = function (e) {
    return "Min(" + e + ")";
  }, c[exports.MetricType.Median] = function (e, t) {
    return t ? "Avg(Median(" + e + "))" : "Median(" + e + ")";
  }, c[exports.MetricType.Sum] = function (e) {
    return e;
  }, c);
function h(e, t, r) {
  if (O()) return Reflect.construct.apply(null, arguments);
  var o = [null];
  o.push.apply(o, t);
  var i = new (e.bind.apply(e, o))();
  return r && D(i, r.prototype), i;
}
function m(e) {
  return (m = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  })(e);
}
function M(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, D(e, t);
}
function O() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (e) {}
  return (O = function () {
    return !!e;
  })();
}
function D(e, t) {
  return (D = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
    return e.__proto__ = t, e;
  })(e, t);
}
function H(e) {
  var t = "function" == typeof Map ? new Map() : void 0;
  return (H = function (e) {
    if (null === e || !function (e) {
      try {
        return -1 !== Function.toString.call(e).indexOf("[native code]");
      } catch (t) {
        return "function" == typeof e;
      }
    }(e)) return e;
    if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
    if (void 0 !== t) {
      if (t.has(e)) return t.get(e);
      t.set(e, r);
    }
    function r() {
      return h(e, arguments, m(this).constructor);
    }
    return r.prototype = Object.create(e.prototype, {
      constructor: {
        value: r,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), D(r, e);
  })(e);
}
exports.DatasetType = void 0, (T = exports.DatasetType || (exports.DatasetType = {})).CODE = "CODE", T.DESIGN_STUDIO = "DESIGN_STUDIO", T.URL = "URL", exports.HighchartsType = void 0, (d = exports.HighchartsType || (exports.HighchartsType = {})).Column = "column", d.Bar = "bar", d.Pie = "pie", d.Line = "line", exports.HighchartsV10Type = void 0, (l = exports.HighchartsV10Type || (exports.HighchartsV10Type = {})).Arcdiagram = "arcdiagram", l.Column = "column", l.Bar = "bar", l.Pie = "pie", l.Line = "line", l.treegraph = "treegraph", exports.HighchartsColumnType = void 0, (x = exports.HighchartsColumnType || (exports.HighchartsColumnType = {})).Basic = "basic", x.Stacked = "stacked", x.Grouped = "grouped", exports.HighchartsBarType = void 0, (y = exports.HighchartsBarType || (exports.HighchartsBarType = {})).Basic = "basic", y.Stacked = "stacked", y.Grouped = "grouped", exports.ColorPaletteType = void 0, (A = exports.ColorPaletteType || (exports.ColorPaletteType = {})).Gradient = "gradient", A.Categorical = "categorical", exports.WidgetSize = void 0, (E = exports.WidgetSize || (exports.WidgetSize = {})).Small = "small", E.Medium = "medium", E.Large = "large", exports.ColGroupShow = void 0, (g = exports.ColGroupShow || (exports.ColGroupShow = {})).Always = "always", g.OnlyWhenCollapsed = "collapsed", g.OnlyWhenExpanded = "expanded", exports.AgGridTheme = void 0, (R = exports.AgGridTheme || (exports.AgGridTheme = {})).condensed = "condensed", R.default = "default", exports.SgConnectEnvironment = void 0, (v = exports.SgConnectEnvironment || (exports.SgConnectEnvironment = {})).Homologation = "homologation", v.Production = "production", exports.BootstrapTheme = void 0, (f = exports.BootstrapTheme || (exports.BootstrapTheme = {})).Standard = "standard", f.Dark = "dark";
var b,
  S,
  B,
  P,
  U = function (e) {
    function t(t) {
      var r,
        o = t.message,
        i = t.redirectUri;
      return (r = e.call(this, void 0 === o ? "" : o) || this).name = "RequestAccessError", r.redirectUri = i, r;
    }
    return M(t, e), t;
  }(H(Error)),
  L = function (e) {
    function t(t) {
      var r;
      return (r = e.call(this, t) || this).name = "UserActionRequiredError", r;
    }
    return M(t, e), t;
  }(H(Error));
exports.Environment = void 0, (b = exports.Environment || (exports.Environment = {})).Development = "development", b.Homologation = "homologation", b.Production = "production", exports.WidgetExportType = void 0, (S = exports.WidgetExportType || (exports.WidgetExportType = {})).Table = "table", S.Text = "text", S.Chart = "chart", exports.ChartType = void 0, (B = exports.ChartType || (exports.ChartType = {})).PIE_CHART = "PIE CHART", B.DONUT = "DONUT", B.LINE_CHART = "LINE CHART", B.COLUMN_CHART = "COLUMN CHART", B.STOCK_CHART = "STOCK CHART", B.BAR_CHART = "BAR CHART", B.BUBBLE_CHART = "BUBBLE CHART", B.GANTT_CHART = "GANTT CHART", B.SCATTER_CHART = "SCATTER CHART", B.TABLE = "TABLE", B.TEXT = "TEXT", B.KPI = "KPI", B.FIGURE = "FIGURE", B.NUMBER = "NUMBER", B.HEATMAP = "HEATMAP", B.AREA_CHART = "AREA CHART", B.LIST = "LIST", B.GAUGE = "GAUGE", B.WORD_CLOUD = "WORD CLOUD", B.MULTI_CHART = "MULTI CHART", B.PIVOT_TABLE = "PIVOT TABLE", B.RADAR_CHART = "RADAR CHART", B.TREE_MAP = "TREE MAP", B.WORLD_MAP = "WORLD MAP", B.NAVIGATION = "NAVIGATION", B.SANKEY_CHART = "SANKEY CHART", B.ORG = "ORG CHART", B.OTHER = "OTHER", exports.BootstrapVersion = void 0, (P = exports.BootstrapVersion || (exports.BootstrapVersion = {})).Three = "3", P.Four = "4", P.Five = "5", exports.RequestAccessError = U, exports.SUB_OBJECT_SEPARATOR = "->", exports.UserActionRequiredError = L, exports.dateTimeFilterOutputEventSuffix = "datetime-updated", exports.filterOutputEventSuffix = "value-updated", exports.formatDate = function (e, t) {
  if (void 0 === t && (t = "dd MMM yyyy"), "string" != typeof e) return "";
  var o = e;
  10 === e.length && (o += "T00:00:00");
  try {
    var i = Date.parse(o);
    if (isNaN(i)) return "";
    var p = new Date(i);
    return r.format(p, t);
  } catch (e) {
    return "";
  }
}, exports.getMetricLabel = function (e, t) {
  var r = e.label;
  void 0 === t && (t = !1);
  var o = C[e.data.type];
  return o ? o(r, t) : r;
}, exports.isQueryModelEnabled = function (e) {
  return !0 === e || "true" === e;
}, exports.isValidHttpUrl = function (e) {
  var t;
  try {
    t = new URL(e);
  } catch (e) {
    return !1;
  }
  return "http:" === t.protocol || "https:" === t.protocol;
}, exports.numericMetricType = u, exports.parseDate = function (e) {
  if ("string" == typeof e) {
    if (/^\d{4}-\d{2}-\d{2}$/.test(e)) {
      var t = e.split("-").map(Number);
      return new Date(t[0], t[1] - 1, t[2], 0, 0, 0, 0);
    }
    return new Date(e);
  }
  return new Date(e);
}, exports.valueRegExp = "{value}";